import { flowBuilderConstants } from '../../../constants/FlowBuilder';

/**
 * Aligns the panned canvas so the leftmost journey step card sits at the same fixed
 * screen anchor as the initiate-step card (mirrors how zoom controls stay put).
 */
export const computeJourneyCardsAnchorTranslation = ({
  stepItems,
  initiateStepCardVisible,
  zoomLevel = flowBuilderConstants.zoomLevelDefault,
  anchorX = flowBuilderConstants.initiateStepCardPosition.x,
  anchorY = flowBuilderConstants.initiateStepCardPosition.y,
}: {
  stepItems: { x: number; y: number }[];
  initiateStepCardVisible: boolean;
  zoomLevel?: number;
  anchorX?: number;
  anchorY?: number;
}): { x: number; y: number } => {
  const contentPoints: { x: number; y: number }[] = [...stepItems];

  if (initiateStepCardVisible) {
    contentPoints.push(flowBuilderConstants.initiateStepCardPosition);
  }

  if (contentPoints.length === 0) {
    return {
      x: flowBuilderConstants.translateXDefault,
      y: flowBuilderConstants.translateYDefault,
    };
  }

  const contentLeft = Math.min(...contentPoints.map((point) => point.x));
  const contentTop = Math.min(...contentPoints.map((point) => point.y));

  return {
    x: anchorX - contentLeft * zoomLevel,
    y: anchorY - contentTop * zoomLevel,
  };
};

/**
 * Pans the canvas so a flow item is centred in the viewport (accounts for zoom).
 */
export const computeFlowItemFocusTranslation = ({
  x,
  y,
  viewportWidth,
  viewportHeight,
  zoomLevel = flowBuilderConstants.zoomLevelDefault,
}: {
  x: number;
  y: number;
  viewportWidth: number;
  viewportHeight: number;
  zoomLevel?: number;
}): { x: number; y: number } => ({
  x: viewportWidth / 2 - x * zoomLevel,
  y: viewportHeight / 2 - y * zoomLevel,
});
